<template>
  <div class="justify-start items-center inline-flex">
    <div v-if="hasImage" class="self-stretch pl-4 py-1 justify-center items-center gap-2.5 flex">
      <div class="flex flex-col justify-center px-[5px] py-2 h-[60px]">
        <Image :media="image" :alt="imageAlt" class="w-10" />
      </div>
    </div>
    <div
      class="grow shrink basis-0 self-stretch justify-start items-center gap-3 flex p-3 data-[noImage=true]:pl-5 data-[isMega=true]:py-4"
      :data-noImage="!hasImage && (isComparison || !isMega)"
      :data-isMega="isMega"
    >
      <div class="grow shrink basis-0 flex-col justify-start items-start gap-0.5 inline-flex">
        <RichText :field="{ value: label }" class="text-racq-dark-grey text-base-bold text-left line-clamp-2" />
        <RichText :field="{ value: help }" class="text-racq-med-grey text-xs text-left" />
      </div>
      <div v-if="rightLabel" class="self-stretch flex-col justify-start items-end inline-flex">
        <RichText :field="{ value: rightLabel }" class="text-racq-dark-grey text-base-bold text-left" />
        <RichText :field="{ value: rightHelp }" class="text-racq-med-grey text-xs text-left" />
      </div>
      <div
        v-if="!hideCheckbox"
        class="justify-center items-center flex flex-col"
        :class="help || isComparison ? 'self-start py-1' : 'self-stretch'"
      >
        <div
          class="w-5 h-5 rounded-full self-stretch justify-center items-center inline-flex"
          :class="isSelected ? 'bg-racq-blue-active' : 'border-2 border-racq-light-blue-grey'"
        >
          <span v-if="isSelected" class="bg-icon-check icon w-3 h-2.5 bg-no-repeat bg-contain"></span>
        </div>
      </div>
    </div>
  </div>
  <slot name="bottom"></slot>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { RichText, Image } from '@sitecore-jss/sitecore-jss-vue';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';

const props = defineProps<{
  label: string;
  help?: string;
  image?: ImageField;
  isSelected: boolean;
  rightLabel?: string;
  rightHelp?: string;
  hideCheckbox?: boolean;
  isMega?: boolean;
  isComparison?: boolean;
}>();

const hasImage = computed(() => !!props.image?.value?.src);

const imageAlt = computed(() => {
  return props.image?.value?.alt || props.label || 'Option image';
});
</script>
